import { Box, Button, Fab, IconButton, Stack, Typography } from "@mui/material"
import './coghandStyle.css'
import { CogHandIconAnimated } from "../../customIcons/CogHandIconAnimated";

export const CogHandButton = ({ handleOpen }) => {

    return (
        <Box sx={{ position: 'absolute', marginLeft: '678px', marginTop: '-25px' }}>
            <Stack direction={'row'} spacing={0.5} alignItems={'center'}>
                <Typography sx={{width: '325px', fontStyle: 'italic', color: 'GrayText'}}>
                    Behöver du hjälp att välja? Prova vår Produktvägledning!
                </Typography>
                <Box className="cog-hand-button" onClick={handleOpen} >
                    <CogHandIconAnimated fontSize={'20px'} />
                </Box>
            </Stack>
        </Box>
    )
}